import { ga4EventNames, normalizeGa4Properties } from './GoogleAnalyticsEvents';

export const GOOGLE_ADS_DESTINATION_ID = 'AW-18428159167';
export const QUIZ_COMPLETE_CONVERSION_ID = 'AW-18428159167/JkzsCLiHy_8cEL_JndNE';
export const CHECKOUT_START_CONVERSION_ID = 'AW-18428159167/K7FuCNzgt4YdEL_JndNE';

const JOURNEY_KEY = 'google-ads-quiz-journey';
const COMPLETED_KEY = 'google-ads-quiz-complete';
const CHECKOUT_START_KEY = 'google-ads-first-checkout-start';
let completedInMemory = false;
let checkoutStartedInMemory = false;
let journeyInMemory = null;

const createJourneyId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `quiz_${crypto.randomUUID()}`;
  }
  return `quiz_${Date.now()}_${Math.random().toString(36).slice(2)}`;
};

const readStorage = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const writeStorage = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // Analytics must continue when browser storage is unavailable.
  }
};

export const beginGoogleAdsQuizJourney = () => {
  const journeyId = createJourneyId();
  journeyInMemory = journeyId;
  completedInMemory = false;
  try {
    sessionStorage.setItem(JOURNEY_KEY, journeyId);
    sessionStorage.removeItem(COMPLETED_KEY);
  } catch {
    // In-memory state still prevents duplicate sends in the current document.
  }
  return journeyId;
};

export const trackGoogleAdsEvent = (eventName, properties = {}) => {
  const adsEventName = ga4EventNames[eventName];
  if (!adsEventName || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return false;
  }

  try {
    window.gtag('event', adsEventName, {
      ...normalizeGa4Properties(properties),
      send_to: GOOGLE_ADS_DESTINATION_ID,
    });
    return true;
  } catch {
    return false;
  }
};

export const trackGoogleAdsQuizComplete = () => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function' ||
      completedInMemory || readStorage(COMPLETED_KEY) === '1') {
    return false;
  }

  const journeyId = readStorage(JOURNEY_KEY) || journeyInMemory || createJourneyId();
  try {
    window.gtag('event', 'conversion', {
      send_to: QUIZ_COMPLETE_CONVERSION_ID,
      transaction_id: journeyId,
    });
    completedInMemory = true;
    journeyInMemory = journeyId;
    writeStorage(JOURNEY_KEY, journeyId);
    writeStorage(COMPLETED_KEY, '1');
    return true;
  } catch {
    return false;
  }
};

export const trackGoogleAdsCheckoutStart = () => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function' ||
      checkoutStartedInMemory || readStorage(CHECKOUT_START_KEY)) return false;
  const checkoutId = `checkout_${createJourneyId().slice(5)}`;
  try {
    window.gtag('event', 'conversion', {
      send_to: CHECKOUT_START_CONVERSION_ID,
      transaction_id: checkoutId,
    });
    checkoutStartedInMemory = true;
    writeStorage(CHECKOUT_START_KEY, checkoutId);
    return true;
  } catch {
    return false;
  }
};
